import { log } from 'log';
import { useCallback } from 'react';

import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useGetPlayerTags = () => {
    const send = useGenericSend();

    return useCallback(async (request: Types.IGetPlayerTagsRequestData = {}): Promise<Types.IGetPlayerTagsResponseData> => {
        const {
            tagNames,
            tagName = tagNames?.join(',') ?? '',
            isJSONParsed, ...other
        } = request;

        const { data } = await send<Types.IGetPlayerTagsRequestData, Types.IGetPlayerTagsResponseData>({
            tagName,
            ...other,
            ID: 35547,
            responses: [35548, 35549],
            description: 'Get player tags',
            errorLevel: 1
        });

        if (isJSONParsed) {
            const tags = data.tags?.map((tag) => {
                try {
                    if (tag.value) {
                        tag.valueParsed = JSON.parse(tag.value);
                    }
                } catch (error) {
                    log('error', 'unable to parse value of get player tags response', error);
                }

                return tag;
            }) ?? [];

            return { tags };
        }

        return data;
    }, [
        send
    ]);
};
